/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const transactionSchema = z.object({
  id: z.string(),
  planKey: z.string(),
  platform: z.string(),
  transactionId: z.string(),
  priceUsd: z.number().nullable(),
  currency: z.string().nullable(),
  purchaseDate: z.number(),
  expiresDate: z.number().nullable(),
  isTrial: z.number(),
  isIntroOffer: z.number(),
  createdAt: z.number(),
});

export type ITransaction = z.infer<typeof transactionSchema>;
